import { Header } from '@studio/design-system/dialog';
import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Panel } from './panel.jsx';

/** Audio settings `<Scaffold>` component. */
export const Scaffold = ({ className, ...props }: HtmlAttributes): ReactElement => (
  <div
    className={twMerge('z-[100] flex min-h-[800px] w-dialog flex-col gap-28', className)}
    {...props}
  >
    <Header title='Advanced settings' />
    <Panel className='grow' />
  </div>
);
